import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { DisplayLabel } from '../models/displayLabel';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TransportModeService {
  constructor(private readonly api: ApiService) {}
  @PCacheable()
  public async findAll(): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.transportModes);
  }
}
